//@ts-nocheck

import blogPagination from "./components/blogPagination";
import consultantsFilter from "./components/consultantsFilter";
import copyCurrentUrl from "./components/copyCurrentUrl";
import faq from "./components/faq";
import header from "./components/header";
import intersection from "./components/intersection";

const init = () => {
    header();
    intersection();
    blogPagination();
    faq();
    consultantsFilter();
    copyCurrentUrl();
};

init();
